import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import { EstadosSolicitudEnumChoice, emptyCell, formatDateWithTime } from '@/shared';
import { IDataCodigoOtp } from '@/shared/interfaces';
import { EstadoCodigoOTPTable } from '../components';
import InfoUser from '@/shared/components/ui/InfoUser/InfoUser';

export const useColumsTableOTPSupervisor = () => {


  const columnsOtpSupervisor = useMemo<MRT_ColumnDef<IDataCodigoOtp>[]>(() => [

    {
      accessorKey: 'celular',
      header: 'Celular',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        emptyCell(row.original.celular.replace('5939', '09'))
      ),
    },
    {
      accessorKey: 'numero_referencia',
      header: '# refencia Prospecto',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.prospecto_data.at(0)?.numero_referencia ?? 'N/A'
      ),
    },
    {
      accessorKey: 'nombre_cliente',
      header: 'Nombre Cliente',
      size: 200,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.prospecto_data.at(0)?.razon_social ?? 'N/A'
      ),
    },
    {
      accessorKey: 'identificacion_cliente',
      header: 'Identificación Cliente',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.prospecto_data.at(0)?.identificacion ?? 'N/A'
      ),
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario solicito',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        <InfoUser
          user={row.original.prospecto_data.at(0)?.user_create ?? 'N/A'}
        />
      ),
    },
    {
      accessorKey: 'otp',
      header: 'OTP',
      size: 50,
    },

    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      size: 50,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.fecha_creacion ?
          formatDateWithTime(row.original.fecha_creacion) : 'N/A'
      ),
    },

    {
      accessorKey: 'estado',
      header: 'Estado',
      size: 180,
      Cell: ({ row }) => {
        return <EstadoCodigoOTPTable estado={!row.original?.validado ? EstadosSolicitudEnumChoice.EN_ESPERA : EstadosSolicitudEnumChoice.APROBADO} />;
      },
    },


  ], []);

  const columnsOTPSupervisorVerificado = useMemo<MRT_ColumnDef<IDataCodigoOtp>[]>(
    () => [
      ...columnsOtpSupervisor,

      // varificado el
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha verificación',
        size: 180,
        Cell: ({ row }) =>
          row.original?.fecha_modificacion
            ? formatDateWithTime(row.original.fecha_modificacion)
            : 'N/A',
      },
    ],
    []
  );

  const columnsOTPSupervisorExpirado = useMemo<MRT_ColumnDef<IDataCodigoOtp>[]>(
    () => [
      ...columnsOtpSupervisor,

      // expirado el - calc based on fecha_creacion and add 10 minutes
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha Expiración',
        size: 180,
        Cell: ({ row }) => {
          const fechaCreacion = new Date(row.original.fecha_creacion);
          const fechaExpiracion = new Date(
            fechaCreacion.getTime() + 10 * 60000
          );
          return formatDateWithTime(fechaExpiracion.toISOString());
        },
      },
    ],
    []
  );




  return {
    columnsOTPSupervisorVerificado,
    columnsOTPSupervisorExpirado,
    columnsOtpSupervisor
  };
};
